// SPU详情页相关页面（SPU是类似于SKU的一个商品概念）
export default {
  routes: [
    // spu详情页 https://act.zhuanzhuan.com/platform/zz-platform-pages/goodsDetailSPU/goodsDetail?needHideHead=1&pageid=889192449&pgcateid=101&pgbrandid=10530&pgmodelid=2190&pgcatetemplateid=&pgseriesid&pgparams=%5B%7B%22paramId%22%3A%225587%22,%22valueId%22%3A%22656778%22%7D,%7B%22paramId%22%3A%226651%22,%22valueId%22%3A%22511434%22%7D%5D&zzv=8.2.0&tt=BE9E896291547F32DDA2172B3C66D75E
    {
      path: '/goodsDetailSPU/goodsDetail',
      name: 'goodsDetailSPUGoodsDetail',
      meta: {
        desc: 'spu详情页'
      },
      component: () =>
        import(
          /* webpackChunkName: "goodsDetailSPUGoodsDetail" */ '../views/goodsDetailSPU/detail/index.vue'
        )
    },
    // 达人测评列表页 https://act.zhuanzhuan.com/platform/zz-platform-pages/goodsDetailSPU/professionCheckList?pgcateid=101&pgbrandid=10530&pgmodelid=2191&pgcatetemplateid=12&pgseriesid=0&pgparams=%255B%257B%2522paramId%2522%3A%25225587%2522,%2522valueId%2522%3A%2522398259%2522%257D,%257B%2522paramId%2522%3A%25226651%2522,%2522valueId%2522%3A%2522678742%2522%257D,%257B%2522paramId%2522%3A%25226652%2522,%2522valueId%2522%3A%2522511439%2522%257D,%257B%2522paramId%2522%3A%25226977%2522,%2522valueId%2522%3A%25221080624%2522%257D,%257B%2522paramId%2522%3A%25227496%2522,%2522valueId%2522%3A%2522880189%2522%257D,%257B%2522paramId%2522%3A%25227497%2522,%2522valueId%2522%3A%25221085528%2522%257D,%257B%2522paramId%2522%3A%25227161%2522,%2522valueId%2522%3A%25221082740%2522%257D%255D
    {
      path: '/goodsDetailSPU/professionCheckList',
      name: 'goodsDetailSPUProfessionCheckList',
      meta: {
        desc: '达人测评列表页'
      },
      component: () =>
        import(
          /* webpackChunkName: "goodsDetailSPUProfessionCheckList" */ '../views/goodsDetailSPU/professionCheckList/index.vue'
        )
    }
  ]
}
